import { render, staticRenderFns } from "./general.vue?vue&type=template&id=716225b2&scoped=true&"
import script from "./general.vue?vue&type=script&lang=js&"
export * from "./general.vue?vue&type=script&lang=js&"
import style0 from "./general.vue?vue&type=style&index=0&lang=css&"
import style1 from "./general.vue?vue&type=style&index=1&id=716225b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716225b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716225b2')) {
      api.createRecord('716225b2', component.options)
    } else {
      api.reload('716225b2', component.options)
    }
    module.hot.accept("./general.vue?vue&type=template&id=716225b2&scoped=true&", function () {
      api.rerender('716225b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/general.vue"
export default component.exports